"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopArea = require("./TopArea");
Object.keys(_TopArea).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopArea[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopArea[key];
    }
  });
});